module.exports = "query loadCheckoutAdjustments{cart{adjustments{id amount isFixed source code}}}"